import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import ReadDelimitedForm from '../forms/read-delimited-form';
import { delimitedReadValidationSchema } from '../schema/delimited.js';

export default function ReadDelimitedNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Read Delimited Node Details',
        altText: 'Read Delimited Node',
        defaultLabel: 'Read Delimited Node',
      }}
    >
      <CommonNode
        FormComponent={ReadDelimitedForm}
        schemaResolver={delimitedReadValidationSchema}
      />
    </NodeProvider>
  );
}
